import React, { Component } from "react";
import { connect } from "react-redux";
import routes from "../../../../routes";
import BreadCrumbs from "../../../../components/BreadCrumbs";
import Enums from "../../../../utils/Enums";
import { renderRoutes } from "../../../../utils/Routes";

class ClientAndPolicyListing extends Component {
  constructor(props) {
    super(props);
    this.HRRoutes = routes.HRRoutes.find(route => route.path === "/auth");
  }

  render() {
    return (
      <main>
        <BreadCrumbs
          currentRoutes={this.HRRoutes.routes[Enums.ROUTE.CLIENT_AND_POLICY_LISTING]}
          pageLabel="dashboard"
        />
        {renderRoutes(this.props.routes)}
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    HR: state.HR
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(ClientAndPolicyListing);
